<template>
  <div class="c-topBanner">
    <div
      class="c-topBanner__item"
      v-for="banner in bannerData"
      :key="banner.img"
    >
      <a :href="banner.url" target="_blank"><img :src="banner.path"/></a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerData: [],
    };
  },
  async mounted() {
    this.bannerData = await this.getBannerJson();
  },
  methods: {
    async getBannerJson() {
      const res = await fetch(
        `${process.env.VUE_APP_BASE_URL}/assets/custom/banner/setting.json`,
      );
      const json = await res.json();
      const bannerShowCategory = json.bannerShowCategory;

      const mansion = this.currentUser.mansion;
      const dai_bunrui = mansion.dai_bunrui;
      const chu_bunrui = mansion.chu_bunrui;
      const mc_code = mansion._id;

      const showBanners = [];
      for (const category in bannerShowCategory) {
        if (category === dai_bunrui) {
          showBanners.push(bannerShowCategory[category]);
        }
        if (category === `${dai_bunrui}/${chu_bunrui}`) {
          showBanners.push(bannerShowCategory[category]);
        }
        if (category === `${dai_bunrui}/${chu_bunrui}/${mc_code}`) {
          showBanners.push(bannerShowCategory[category]);
        }
      }

      let joinShowBanners = [];
      showBanners.map(banners => {
        banners.map(_ => {
          joinShowBanners.push(_);
        });
      });

      const bannerPaths = joinShowBanners.map(banner => {
        return {
          path: `${process.env.VUE_APP_BASE_URL}/assets/custom/banner/img/${banner.img}`,
          url: banner.url,
        };
      });

      return bannerPaths;
    },
  },
};
</script>

<style></style>
